import React, { useState } from 'react'
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import AddIcon from 'components/material-symbol/icons/Add'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import ErrorView from 'components/error'
import { PageHeader } from 'components/page-header'
import ApolloDataView from 'components/apollo-data-view'
import CoachAddStudentModal from 'components/add-student-modal/coach-add-student-modal'
import ExportStudentListDialog from './export-student-list-dialog'
import StudentListView from './student-list-new-view'
import LoadingView from './loading-view'
import { DateTime } from 'luxon'
import { useGetStudents, useGetUpcomingSessions } from './api-hooks'

const StudentsPage = React.memo(() => {
  const [openStudentDialog, setOpenStudentDialog] = useState(false)
  const [openExportDialog, setOpenExportDialog] = useState(false)
  const { path } = useRouteMatch()
  const { loading, error, data, refetch } = useGetStudents()

  const upcomingBookingsDateRange = {
    from: DateTime.now()
      .startOf('day')
      .toISO(),
    to: null,
  }

  const {
    loading: sessionsLoading,
    error: sessionsError,
    data: sessionsData,
    refetch: sessionsRefetch,
  } = useGetUpcomingSessions(upcomingBookingsDateRange, 'ASC')

  const pageLoading = loading || sessionsLoading

  const actions = (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={() => setOpenExportDialog(true)}
        disabled={loading || data?.coachStudents?.length === 0}
      >
        Export List
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="large"
        startIcon={<AddIcon />}
        onClick={() => setOpenStudentDialog(!openStudentDialog)}
      >
        Create Student
      </Button>
    </>
  )

  return (
    <>
      <PageHeader
        title="Students"
        actions={actions}
        fixedMobileActions
        keepActionsInline
      />
      <Switch>
        <Route exact path={`${path}`}>
          <Redirect to={`${path}/list`} />
        </Route>
        <Route
          path={`${path}/list`}
          exact
          component={() => (
            <ApolloDataView
              error={error || sessionsError}
              loading={pageLoading}
              data={data?.coachStudents}
            >
              {{
                errorView: <ErrorView />,
                emptyView: (
                  <StudentListView
                    students={[]}
                    sessions={sessionsData}
                    refetchStudents={refetch}
                    refetchSessions={sessionsRefetch}
                  />
                ),
                loadingView: <LoadingView />,
                dataView: students => (
                  <StudentListView
                    students={students}
                    sessions={sessionsData}
                    refetchStudents={refetch}
                    refetchSessions={sessionsRefetch}
                  />
                ),
              }}
            </ApolloDataView>
          )}
        />
      </Switch>
      <CoachAddStudentModal
        {...{
          open: openStudentDialog,
          setOpen: setOpenStudentDialog,
          onAdd: refetch,
        }}
      />
      <ExportStudentListDialog
        open={openExportDialog}
        onClose={() => setOpenExportDialog(false)}
        students={data?.coachStudents}
      />
    </>
  )
})

export default StudentsPage
